import {Trans} from '@lingui/macro';
import React from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Styles.
 */

const StyledOrAndLabel = styled.div`
  margin: 4px 0;
  text-align: center;
  font-size: ${fontSizes.veryTiny};
  line-height: 1.2;
  font-weight: ${fontWeights.semibold};
  text-transform: uppercase;
`;

const StyledOrLabel = styled(StyledOrAndLabel)`
  color: ${(p) => p.theme.greys.shade60};
`;

export const StyledDropdownGroupTitleWrapper = styled.div`
  font-size: ${fontSizes.medium};
  font-weight: ${fontWeights.semibold};
  color: ${(p) => p.theme.greys.shade80};
`;

/*
 * Components.
 */

export const AndLabel = () => (
  <StyledOrAndLabel>
    <Trans id="rule-editor-and-lowercase">and</Trans>
  </StyledOrAndLabel>
);

export const OrLabel = () => (
  <StyledOrLabel>
    <Trans id="rule-editor-or-lowercase">or</Trans>
  </StyledOrLabel>
);
